'use client'

import React, { useEffect } from 'react'

export default function () {
	useEffect(() => {
		const head = document.querySelector("head")!
		const script = document.createElement("script")
		script.setAttribute(
			"src",
			"https://assets.calendly.com/assets/external/widget.js"
		);
		head.appendChild(script);
	}, []);
	return (
		<div className='block md:block max-w-4xl m-auto'>
      <h1 className="text-3xl font-bold text-center mb-4">Schedule a Meeting</h1>
      <p className="text-center mb-8">
        Want to learn more about how Dessert Data can serve your business?<br/>
        Schedule a call!
      </p>
			<section className="m-auto text-center">
				<div className="calendly-inline-widget" data-url="https://calendly.com/parris-dessertdata" style={{minWidth:"320px", height:"700px"}}></div>
				<script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
			</section>
		</div>
	)
}